module.exports = __webpack_public_path__ + "static/media/whitemain.ba6f91ee.png";